// Presentation adapter: the original select remains the calculator's source of truth.
class WallMaterialPicker extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('#material-select');
    this.options = this.querySelector('.wall-material-options');
    if (!this.select || !this.options || this.observer) return;
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.options.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"]')) return;
      this.select.value = event.target.value;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.sync();
    }, { signal });
    this.select.addEventListener('change', () => this.sync(), { signal });
    // Currency and restored state already update the original option labels.
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.select, { childList: true, subtree: true, characterData: true, attributes: true });
    window.addEventListener('pageshow', () => this.sync(), { signal });
    this.sync();
    this.options.hidden = false;
    this.setAttribute('data-enhanced', 'true');
    this.drawer = document.getElementById('material-modal');
    this.drawer?.addEventListener('close', () => {
      // Includes Escape and backdrop dismissal as well as the close button.
      document.body.style.overflow = '';
    }, { signal });
  }

  sync() {
    for (const option of this.select.options) {
      const radio = Array.from(this.options.querySelectorAll('input')).find(input => input.value === option.value);
      if (!radio) continue;
      radio.checked = option.selected;
      radio.disabled = option.disabled;
      const price = radio.closest('label').querySelector('[data-material-price]');
      // Use the existing formatted currency label verbatim; do not recalculate prices.
      const label = option.textContent.trim();
      const start = label.indexOf('(');
      price.textContent = start >= 0 ? label.slice(start + 1).replace(/\)$/, '') : label;
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.observer?.disconnect();
    this.observer = null;
  }
}
if (!customElements.get('wall-material-picker')) customElements.define('wall-material-picker', WallMaterialPicker);
